import React, { useState, useEffect } from "react";
import styled, { createGlobalStyle } from "styled-components";



import { useSearchParams } from 'react-router-dom';
import { spacing } from '@mui/system';
import {
  CssBaseline,
  Paper as MuiPaper,
  useTheme,
  useMediaQuery
  // withWidth,
} from "@mui/material";

import setAuthToken from "../utils/setAuthToken";

// import { useIsWidthUp } from "@mui/material/withWidth";


// COMPONENTS
import SidebarNEW from "../components/Layouts/DashboardLayout/SidebarNEW";
import TemplateSidebar from "../components/Templates/TemplateSidebar";
import DashboardHeaderBar from "../components/Layouts/DashboardLayout/DashboardHeaderBar";
// HELPER FUNCTIONS
import useWindowDimensions from "../helpers/useWindowDimensions";
// CSS STYLES
import styles from '../styles/layouts/DashboardLayout.module.css'

const drawerWidth = 258;


const Dashboard = ({ children, routes }) => {
    const [mobileOpen, setMobileOpen] = useState(false);

    const theme = useTheme()

    const useIsWidthUp = (breakpoint) => {
        return useMediaQuery(theme.breakpoints.up(breakpoint))
    }

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };
    const pathname = window?.location?.pathname

    const {width} = useWindowDimensions();





    return (
        <div className={styles.dashboardLayout_main_root_wrapper}>

                {/* <Paper sx={{ display: { md: 'block', xl: 'none' } }}>
                    {
                        pathname === '/onsite-content/template' ?
                            <TemplateSidebar
                                routes={routes}
                                PaperProps={{ style: { width: drawerWidth } }}
                                variant="temporary"
                                open={mobileOpen}
                                onClose={handleDrawerToggle}
                            />
                        :
                            <SidebarNEW
                                routes={routes}
                                PaperProps={{ style: { width: drawerWidth } }}
                                isMobile={true}
                                open={mobileOpen}
                                onClose={handleDrawerToggle}
                            />
                    }
                </Paper> */}

                {
                    pathname === '/onsite-content/template' ?
                        ((width >= 960 || mobileOpen && width >= 650) ?
                            <TemplateSidebar
                                routes={routes}
                                PaperProps={{ style: { width: drawerWidth } }}
                                onClose={handleDrawerToggle}
                            />
                        : null)
                    :
                        <SidebarNEW
                        routes={routes}
                        PaperProps={{ style: { width: drawerWidth } }}
                        isMobile={width && width < 960 ? true : false}
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                        />
                }


            
                {/* CHILDREN MAIN WRAPPER - WIDTH EQUALS 100% MINUS LEFT NAVBAR WIDTH */}
                <div className={styles.dashboardLayout_main_children_wrapper}>
                    <DashboardHeaderBar onDrawerToggle={handleDrawerToggle} />
                    <div  className={`${styles.dashboardLayout_children_container} 
                    ${pathname === '/onsite-content/template' ? styles.dashboardLayout_template_children_container : ''}
                    `}>
                        {children}
                    </div>
                </div>
        </div>
    );
};

export default (Dashboard);
